
import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import Modal from "./Modal.vue";
import {getPreference, setPreference} from "../Core/Preferences";
import {settings, SettingsService} from "../Core/Settings";
import {VueInject} from "../VueIntegration/VueInjectable";

@Component({
    components: {Modal}
})
export default class Settings extends Vue {
    @VueInject("SettingsService") settingsService: SettingsService;
    volume = settings.volume;
    closedCaptions = settings.closedCaptions;
    playbackSpeed = settings.playbackSpeed;
    readerMode = settings.readerMode;

    close() {
        this.$emit('close');
    }

    @Watch('volume')
    @Watch('closedCaptions')
    @Watch('playbackSpeed')
    @Watch('readerMode')
    @Watch('focusColor')
    change() {
        this.settingsService.setSetting('volume', +this.volume);
        this.settingsService.setSetting('closedCaptions', this.closedCaptions);
        this.settingsService.setSetting('playbackSpeed', +this.playbackSpeed);
        this.settingsService.setSetting('readerMode', this.readerMode);
    }
}
